import * as React from 'react'
import type { SVGProps } from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import { CommonComponentProps } from '@pijma/hero-types'

export const IconLike = (
  props: SVGProps<SVGSVGElement> & CommonComponentProps,
) => (
  <PijmaComponent
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    as="svg"
    commonProps={props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1255 1C12.0634 0.999997 11.0878 1.58536 10.588 2.52248L7.61527 8.09642C7.42144 8.03382 7.21467 8 7 8H5C3.89543 8 3 8.89543 3 10V18C3 19.1046 3.89543 20 5 20H7C7.68484 20 8.28928 19.6558 8.64976 19.1309C8.97389 19.3239 9.34519 19.5261 9.71548 19.6848C10.0759 19.8392 10.5413 20 11 20H16.841C18.2859 20 19.5229 18.9705 19.7885 17.552L20.9453 11.3717C21.2735 9.61884 20.0091 7.96845 18.2312 7.82894L15.2311 7.59352L15.9301 4.51196C16.3382 2.71271 14.9705 1 13.1255 1ZM9 16.9826C9.17777 17.1034 9.39957 17.2485 9.63953 17.3925C9.93131 17.5676 10.2324 17.7304 10.5033 17.8465C10.638 17.9042 10.7533 17.9452 10.8471 17.9708C10.8933 17.9834 10.9299 17.991 10.9575 17.9954C10.9711 17.9975 10.9814 17.9987 10.9888 17.9994L10.9972 17.9999L10.9993 18L16.841 18C17.3215 18 17.7339 17.6579 17.8226 17.184L18.9795 11.0037C19.0889 10.4194 18.6674 9.86932 18.0748 9.82281L13.9218 9.49693C13.6323 9.47422 13.367 9.32678 13.1948 9.09295C13.0226 8.85911 12.9606 8.56198 13.0248 8.27878L13.9796 4.06954C14.1039 3.52159 13.6874 3 13.1255 3C12.8021 3 12.505 3.17827 12.3527 3.46366L8.98735 9.77378C8.99571 9.84803 9 9.92351 9 10V16.9826ZM5 10H7V18H5V10Z"
      fill="currentColor"
    />
  </PijmaComponent>
)
